
import svgComponents from './icon'
// console.log('requireSvg.svgComponents', svgComponents);

export default {
	components: svgComponents
}
